"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const connection_json_1 = require("./connection-json");
exports.ConnectionDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Connection', connection_json_1.ConnectionJsonMapper);
